import { useLegacyCsbApi } from "./api/useLegacyCsbApi";

export type GetAuthToken = () => Promise<string>;

export interface AuthTokenResponseBody {
  data: {
    token: string;
  };
}

export function useAuthToken() {
  return useLegacyCsbApi<GetAuthToken>((api) => {
    return () => {
      return api.rest
        .get<AuthTokenResponseBody>({
          path: "/v1/auth/auth-token",
        })
        .then((res) => {
          return res.data.token;
        });
    };
  });
}
